class ZerraHeroSlider {
  constructor(el) {
    this.el = el;
    this.slides = [...el.querySelectorAll('[data-slide]')];
    this.dots = [...el.querySelectorAll('[data-dot]')];
    this.current = 0;
    this.busy = false;
    this.autoplay = el.dataset.autoplay === 'true';
    this.interval = parseInt(el.dataset.interval || '5000', 10);
    this.timer = null;
    this.isPaused = false;
    this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    this.transitionMs = this.reduceMotion ? 100 : 520;

    this.dots.forEach((dot, i) => {
      dot.addEventListener('click', () => this.go(i));
    });

    el.addEventListener('mouseenter', () => {
      this.isPaused = true;
      this.stopAutoplay();
    });
    el.addEventListener('mouseleave', () => {
      this.isPaused = false;
      this.startAutoplay();
    });
    el.addEventListener('focusin', () => {
      this.isPaused = true;
      this.stopAutoplay();
    });
    el.addEventListener('focusout', (e) => {
      if (!el.contains(e.relatedTarget)) {
        this.isPaused = false;
        this.startAutoplay();
      }
    });

    this.playIntro();
  }

  playIntro() {
    if (!this.slides.length) return;

    if (this.reduceMotion) {
      this.sync(0, false);
      this.startAutoplay();
      return;
    }

    this.busy = true;
    const first = this.slides[0];

    this.slides.forEach((slide, i) => {
      slide.classList.remove('is-active', 'is-leaving');
      slide.setAttribute('aria-hidden', i === 0 ? 'false' : 'true');
    });

    this.dots.forEach((dot, i) => {
      const active = i === 0;
      dot.classList.toggle('is-active', active);
      dot.setAttribute('aria-selected', active ? 'true' : 'false');
    });

    // Partenza off-stage → ingresso come nello slideshow
    void first.offsetWidth;

    requestAnimationFrame(() => {
      first.classList.add('is-active');
      this.current = 0;

      window.setTimeout(() => {
        this.busy = false;
        this.startAutoplay();
      }, this.transitionMs);
    });
  }

  sync(index, animate) {
    this.current = (index + this.slides.length) % this.slides.length;

    this.slides.forEach((slide, i) => {
      const active = i === this.current;
      slide.classList.toggle('is-active', active);
      slide.classList.remove('is-leaving');
      slide.setAttribute('aria-hidden', active ? 'false' : 'true');
    });

    this.dots.forEach((dot, i) => {
      const active = i === this.current;
      dot.classList.toggle('is-active', active);
      dot.setAttribute('aria-selected', active ? 'true' : 'false');
    });

    if (animate === false) return;
  }

  go(index) {
    if (!this.slides.length || this.busy) return;

    const next = (index + this.slides.length) % this.slides.length;
    if (next === this.current) return;

    if (this.reduceMotion) {
      this.sync(next, false);
      this.restartAutoplay();
      return;
    }

    this.busy = true;
    const currentSlide = this.slides[this.current];
    const nextSlide = this.slides[next];

    currentSlide.classList.add('is-leaving');
    currentSlide.classList.remove('is-active');

    // Force reflow so enter transition runs from off-stage state
    nextSlide.classList.remove('is-active');
    void nextSlide.offsetWidth;
    nextSlide.classList.add('is-active');
    nextSlide.setAttribute('aria-hidden', 'false');

    this.dots.forEach((dot, i) => {
      const active = i === next;
      dot.classList.toggle('is-active', active);
      dot.setAttribute('aria-selected', active ? 'true' : 'false');
    });

    window.setTimeout(() => {
      currentSlide.classList.remove('is-leaving');
      currentSlide.setAttribute('aria-hidden', 'true');
      this.current = next;
      this.busy = false;
    }, this.transitionMs);

    this.restartAutoplay();
  }

  startAutoplay() {
    if (!this.autoplay || this.isPaused || this.slides.length < 2) return;
    this.stopAutoplay();
    this.timer = setInterval(() => this.go(this.current + 1), this.interval);
  }

  stopAutoplay() {
    if (this.timer) clearInterval(this.timer);
    this.timer = null;
  }

  restartAutoplay() {
    this.stopAutoplay();
    this.startAutoplay();
  }
}

function initZerraHeroSliders(root = document) {
  root.querySelectorAll('.zerra-hero-slider:not([data-slider-init])').forEach((el) => {
    el.setAttribute('data-slider-init', 'true');
    new ZerraHeroSlider(el);
  });
}

document.addEventListener('DOMContentLoaded', () => initZerraHeroSliders());
document.addEventListener('shopify:section:load', (e) => initZerraHeroSliders(e.target));
